import DevicePanelMixinPanel from '../components_mixins/DevicePanelMixinPanel';

export const DevicePanelMixin = {
    data() {
        return {
            showDevicePanel: false,
            showSettingsDevicePanel: false,
            settingsDevice: null,
            settingsLocation: null,
        };
    },
    provide() {
        return { parentDevicePanelMixin: this };
    },
    components: { DevicePanelMixinPanel },
    methods: {
        openDevicePanel(device) {
            this.settingsDevice = device;
            this.showDevicePanel = true;
        },
        openSettingsDevicePanel(data) {
            this.settingsDevice = data.device;
            this.settingsLocation = data.location;
            this.showSettingsDevicePanel = true;
        },
    },
};
